import { useDetalheEscopoMacro } from "./use-detalhe-escopo-macro";
import { DetalheEscopoMacroView } from "./view-detalhe-escopo-macro";
import type { DetalheEscopoMacroProps } from "./types-detalhe-escopo-macro";

export function DetalheEscopoMacro(props: DetalheEscopoMacroProps) {
  const vm = useDetalheEscopoMacro(props);

  return <DetalheEscopoMacroView {...vm} />;
}

export type * from "./types-detalhe-escopo-macro";
